module.exports = __webpack_public_path__ + "static/media/11.621ba79f.jpg";